import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";
import { toast } from "react-toastify";

export const fetchProvidersStart = () => {
  return {
    type: actionTypes.FETCH_PROVIDERS_START,
  };
};
export const fetchProvidersSuccess = (providers) => {
  return {
    type: actionTypes.FETCH_PROVIDERS_SUCCESS,
    providers: providers,
  };
};
export const fetchProvidersFailed = (errorMessage) => {
  return {
    type: actionTypes.FETCH_PROVIDERS_FAILED,
    errorMessage: errorMessage,
  };
};

export const fetchProviders = (searchParams) => {
  return (dispatch) => {
    dispatch(fetchProvidersStart());
    let queryParams = "";
    if (searchParams.currentAttempt === 1) {
      queryParams = queryParams.concat("?distance=" + searchParams.distance);
    } else if (searchParams.currentAttempt === 2) {
      queryParams = queryParams.concat(
        "?distance=" + searchParams.extendedDistance
      );
    }
    if (
      searchParams.fetchCurrentLocation &&
      searchParams.longitude &&
      searchParams.latitude
    ) {
      queryParams = queryParams.concat("&longitude=" + searchParams.longitude);
      queryParams = queryParams.concat("&latitude=" + searchParams.latitude);
    } else if (searchParams.postalCode && searchParams.postalCode !== "")
      queryParams = queryParams.concat(
        "&postalCode=" + searchParams.postalCode
      );

    if (searchParams.providerName && searchParams.providerName !== "")
      queryParams = queryParams.concat(
        "&providerName=" + encodeURIComponent(searchParams.providerName)
      );

    if (searchParams.providerType)
      queryParams = queryParams.concat(
        "&providerType=" + encodeURIComponent(searchParams.providerType)
      );

    if (searchParams.specialty)
      queryParams = queryParams.concat("&specialty=" + searchParams.specialty);

    if (searchParams.isFavorite)
      queryParams = queryParams.concat(
        "&isFavorite=" + searchParams.isFavorite
      );
    // if (searchParams.isContracted)
    //   queryParams = queryParams.concat(
    //     "&isContracted=" + searchParams.isContracted
    //   );
    if (searchParams.contractStatus)
      queryParams = queryParams.concat(
        "&contractStatus=" + searchParams.contractStatus
      );
    if (searchParams.scoreHigherThan > 0 || searchParams.scoreLowerThan < 10) {
      queryParams = queryParams.concat(
        "&scoreHigherThan=" + searchParams.scoreHigherThan
      );
      queryParams = queryParams.concat(
        "&scoreLowerThan=" + searchParams.scoreLowerThan
      );
    }
    if (searchParams.gender && searchParams.gender !== "Gender")
      queryParams = queryParams.concat("&gender=" + searchParams.gender);
    // "&limit=" +
    // searchParams.limit +
    queryParams = queryParams.concat(
      "&userId=" +
        localStorage.getItem("userId") +
        "&clientId=" +
        localStorage.getItem("clientId") +
        "&clientGroupId=" +
        localStorage.getItem("clientGroupId")
    );

    axios
      .get(serverconfigs.fetchProvidersUrl + queryParams)
      .then((response) => {
        console.log(response.data);
        dispatch(fetchProvidersSuccess(response.data.result));
      })
      .catch((error) => {
        const errors =
          error.response.data.message ??
          error.response.data.result ??
          error.message;
        const errorMessage = Array.isArray(errors) ? errors[0] : errors;

        // TODO: this should be move to an interceptor
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }

        dispatch(fetchProvidersFailed(errorMessage));
        // Show a toast when an error occurs...
        toast.error(errorMessage, {
          toastId: "fetchProvidersFailed",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 10000,
          hideProgressBar: true,
          closeOnClick: true,
          progress: undefined,
        });
      });
  };
};
